import { pageView, track } from '@dafiti/analytics-sdk';
import isMobile from '../utils/helper/device';
import { trackAnaEvent } from './anaAnalytics';
import { useConfig } from './ConfigProvider';
import { GoogleTagManagerProps } from './types';

declare global {
  interface Window {
    dataLayer: GoogleTagManagerProps[];
  }
}

export enum GoogleAnalyticsConstants {
  LOGIN_SCREEN_VIEW = 'login_screen_view_ga4',
  LOGIN = 'login_ga4',
  SIGN_UP = 'sign_up_ga4',
  CUSTOMER_PHONE_ENABLED = 'customer_phone_flag',
  CUSTOMER_PHONE_REQUIRED = 'customer_phone_required_flag',
}

export const eventLoginSuccess = (method: string) => {
  if (window && window.dataLayer) {
    const event = GoogleAnalyticsConstants.LOGIN;
    const device = isMobile() ? 'msite' : 'desktop';

    track(event, {
      ab_test_name: `new_login_front_${device}`,
      ab_test_variant: 'ligado',
      method: method,
    });

    trackAnaEvent({
      event_name: 'login',
      properties: {
        ab_test_name: `new_login_front_${device}`,
        ab_test_variant: 'ligado',
        method: method,
      },
    });
  }
};

export const eventSignUpSuccess = (method: string) => {
  if (window && window.dataLayer) {
    const event = GoogleAnalyticsConstants.SIGN_UP;
    const device = isMobile() ? 'msite' : 'desktop';

    track(event, {
      ab_test_name: `new_login_front_${device}`,
      ab_test_variant: 'ligado',
      method: method,
    });
  }
};

export const pushPageViewDataLayer = (page: string, event: string) => {
  // Verifica se o dataLayer está disponível
  if (window && window.dataLayer) {
    pageView(
      {
        path: window.location.pathname,
        location: window.location.href,
        title: page,
      },
      {
        buyerType: event,
      },
    );

    trackAnaEvent({
      event_name: 'page_view',
      properties: {
        path: window.location.pathname,
        location: window.location.href,
        title: page,
        buyer_type: event,
      },
    });
  } else {
    console.log('dataLayer is not defined');
  }
};

export const eventABActivationTest = (event: string) => {
  if (window && window.dataLayer) {
    const device = isMobile() ? 'msite' : 'desktop';
    window.dataLayer = window.dataLayer ? window.dataLayer : [];

    track(event, {
      ab_test_name: `new_login_front_${device}`,
      ab_test_variant: 'ligado',
    });

    trackAnaEvent({
      event_name: 'ab_test_event',
      properties: {
        ab_test_name: `new_login_front_${device}`,
        ab_test_variant: 'ligado',
        event,
      },
    });
  }
};

export const sendErrorToGa = (
  trigger: string,
  errorType: string,
  errorName: string,
) => {
  if (window && window.dataLayer) {
    track('error_event_ga4', {
      error_trigger_time: trigger,
      error_type: errorType,
      error_name: errorName,
    });
  }
};

export default () => {
  const config = useConfig();
  const gtmId = config ? config.REACT_APP_GOOGLE_TAG_MANAGER : '';

  const script = document.createElement('script');
  script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
  document.head.appendChild(script);
};
